export class PerfilFormulario {
	// Alimentar los inputs
	Id: string;
	Nomobre: string;
	PesoMAximo: string;
	Idiomas: Map<string, PerfilIdiomaFormulario>;

	// Objeto de Breeze
	ENTIDAD: any;

	constructor(perfil?) {
		this.Nomobre = '';
		this.Id = '';
		this.PesoMAximo = ' 0';
		this.ENTIDAD = {};
		this.Idiomas = new Map<string, PerfilIdiomaFormulario>();

		if (perfil) {

			this.ENTIDAD = perfil;
			this.Id = perfil.Id;
			this.Nomobre = perfil.Nomobre;
			this.PesoMAximo = perfil.PesoMAximo;

			perfil.IDIOMAS.forEach(element => {
				const aux = new PerfilIdiomaFormulario(element);
				this.Idiomas.set(element.IDIOMA.Codigo, aux);
			});
		}


	}
}

export class PerfilIdiomaFormulario {

	Codigo: string;
	Nombre: string;


	constructor(espacioIdioma?) {

		if (espacioIdioma) {
			this.Codigo = espacioIdioma.IDIOMA.Codigo ? espacioIdioma.IDIOMA.Codigo : '';
			this.Nombre = espacioIdioma.Nombre ? espacioIdioma.Nombre : '';
		}
		else{
			this.Codigo = '';
			this.Nombre = '';
		}

	 }
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/PerfilFormulario.ts